import React from 'react';
import EmojiIcon from '#web-components/components/Icons/EmojiIcon';
import type { EmojiIconProps } from '#web-components/components/Icons/EmojiIcon/EmojiIcon';
// https://emojipedia.org/hourglass-done/
export default function HourGlassIcon(props: Omit<EmojiIconProps, 'children'> = {}) {
  return (
    <EmojiIcon {...props}>⌛</EmojiIcon>
  );
}
